import axios from "axios"
import { getApiBaseUrl } from "./baseApi"

axios.defaults.withCredentials = true

class ServerInstance {

    constructor() {
        this.serverUrl = getApiBaseUrl()
        this.api = axios.create({
            baseURL: this.serverUrl,
            withCredentials: true
        })
    }

    async get(endpoint) {
        console.log(endpoint);

        try {
            const response = await this.api.get(`/${endpoint}`)
            return response.data
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    async post(endpoint, data, headers = {}) {

        try {
            const response = await this.api.post(`/${endpoint}`, data)
            return response.data;
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    async patch(endpoint, data) {
        try {
            const response = await this.api.patch(`/${endpoint}`, data)
            return response.data
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    async delete(endpoint) {
        try {
            const response = await this.api.delete(`/${endpoint}`)
            return response.data
        } catch (error) {
            console.error(error)
            throw error
        }
    }
}

export default ServerInstance